/**
 * TD Product Showcase Component
 * Handles card interactions and animations
 */

(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 767;
  const SELECTORS = {
    section: '.td-product-showcase-section',
    card: '[data-td-showcase-card]',
    trigger: '[data-td-showcase-trigger]',
    content: '[data-td-showcase-content]'
  };

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function isStaticOpenSection(sectionEl) {
    return sectionEl.dataset.tdStaticOpen === 'true';
  }

  function setCardExpandedState(card, shouldExpand) {
    const productContent = card.querySelector(SELECTORS.content);

    if (!productContent || card.classList.contains('td-overlay-card')) {
      return;
    }

    productContent.classList.toggle('active', shouldExpand);
    card.classList.toggle('td-card-active', shouldExpand);
  }

  function applyDefaultOpenState(sectionEl) {
    if (isStaticOpenSection(sectionEl)) {
      return;
    }

    const openAllMobile = sectionEl.dataset.openAllMobile === 'true';
    const openAllDesktop = sectionEl.dataset.openAllDesktop === 'true';
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    const shouldExpand = isMobile ? openAllMobile : openAllDesktop;

    sectionEl.querySelectorAll(SELECTORS.card).forEach((card) => {
      setCardExpandedState(card, shouldExpand);
    });
  }

  function initSection(sectionEl) {
    if (!sectionEl) {
      return;
    }

    if (sectionEl.dataset.tdShowcaseInitialized !== 'true') {
      const showcaseCards = sectionEl.querySelectorAll(SELECTORS.card);

      showcaseCards.forEach((card) => {
        const productImage = card.querySelector(SELECTORS.trigger);
        const productContent = card.querySelector(SELECTORS.content);

        if (!productImage || !productContent || card.classList.contains('td-overlay-card')) {
          return;
        }

        if (isStaticOpenSection(sectionEl)) {
          setCardExpandedState(card, true);
          return;
        }

        productImage.addEventListener('click', function() {
          productContent.classList.toggle('active');
          card.classList.toggle('td-card-active');
        });
      });

      sectionEl.dataset.tdShowcaseInitialized = 'true';
    }

    applyDefaultOpenState(sectionEl);
  }

  function initTdProductShowcase() {
    document.querySelectorAll(SELECTORS.section).forEach((sectionEl) => {
      initSection(sectionEl);
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTdProductShowcase);
  } else {
    initTdProductShowcase();
  }

  // Re-initialize when Shopify section is loaded/reloaded
  document.addEventListener('shopify:section:load', function(event) {
    const sectionEl = event.target.querySelector(SELECTORS.section);

    if (sectionEl) {
      initSection(sectionEl);
    }
  });

  // Re-apply default behavior on breakpoint changes
  window.addEventListener('resize', debounce(initTdProductShowcase, 250));
})();
